/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { emailRegex } from 'helpers/validators';
import { Form } from 'cvlib';
import { GetRegion } from 'constants.js';
import { useSelector } from 'react-redux';
import './EmailForm.scss';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';

const EmailForm = props => {
  const {
    Onboarding_IniciaSesionRCU_Form_TextoTitulo,
    Onboarding_IniciaSesionRCU_Form_TextoSubTitulo_Mail,
    Onboarding_IniciaSesionRCU_TextoPlaceholder1_Mail,
    Onboarding_IniciaSesionRCU_TextoBotonPrimario,
    Onboarding_IniciaSesionRCU_TextoBotonSecundario,
    Onboarding_IniciaSesionRCU_TextoBotonFacebook,
    Onboarding_IniciaSesionRCU_Texto1,
    Onboarding_IniciaSesionRCU_Texto2,
    email_tooltip_valid_label_validation,
    loginMail_tooltip_error_label,
    login_access_title_label,
    login_access_description_label,
    login_access_option_button_next,
    login_access_option_button_cancel,
    login_access_register_label_link,
    Onboarding_IniciaSesionRCU_TextoToggle1,
    Onboarding_IniciaSesionRCU_TextoBotonSecundario1,
    Onboarding_IniciaSesionRCU_TextoBotonApple,
    login_access_apple_button_login,
    login_access_facebook_button_login,
    login_access_placeHolder_textfield,
    password_tooltip_completeField_label_validation,
    telmex_chat_text,
  } = props.translations;
  const {
    onNextClicked,
    onCancelClicked,
    onChatClicked,
    onRegisterClicked,
    emailValid,
    onFacebookClicked,
    onAppleClicked,
    clearValidEmailError,
    isLogingInWithFacebook,
  } = props;
  const [emptyEmail, setEmptyEmail] = useState(true);
  const claroAdEnable = useSelector(state => getClaroAdsKey(state));
  let elements = [
    {
      element: 'title',
      content: claroAdEnable ? Onboarding_IniciaSesionRCU_Form_TextoTitulo : login_access_title_label,
      className: 'flexGrowZero formTitle',
    },
    {
      element: 'group',
      direction: 'vertical',
      className: 'flexGrowZero formInputGroup',
      children: [
        {
          element: 'subtitle',
          content: claroAdEnable ? Onboarding_IniciaSesionRCU_Form_TextoSubTitulo_Mail : login_access_description_label,
          className: 'flexGrowZero formSubtitle',
        },
        {
          element: 'item',
          className: 'flexGrowZero formInput mt-24',
          type: 'email',
          placeholder: claroAdEnable ? Onboarding_IniciaSesionRCU_TextoPlaceholder1_Mail :  login_access_placeHolder_textfield,
          message: email_tooltip_valid_label_validation,
          error: !emailValid && loginMail_tooltip_error_label,
          name: 'emailLogin',
          id: 'emailLogin',
          autoFocus: true,
          registerOptions: {
            required: password_tooltip_completeField_label_validation,
            pattern: {
              value: emailRegex,
              message: email_tooltip_valid_label_validation,
            },
          },
          onChange: ({ target }) => setEmptyEmail(target.value.length <= 0),
          onKeyUp: ({ keyCode }) => {
            if (keyCode === 13) {
              const submitButton = document.getElementById('submitEmail');
              submitButton.click();
            }
          },
          clearOtherErrors: clearValidEmailError,
        },
      ],
    },
    {
      element: 'button',
      type: 'red',
      content: claroAdEnable ? Onboarding_IniciaSesionRCU_TextoBotonPrimario : login_access_option_button_next,
      submit: onNextClicked,
      dimmed: emptyEmail,
      id: 'submitEmail',
      className: 'flexGrowZero formButton mt-40',
    },
    {
      element: 'button',
      type: 'gray',
      content: claroAdEnable ? Onboarding_IniciaSesionRCU_TextoBotonSecundario : login_access_option_button_cancel,
      onClick: onCancelClicked,
      id: 'btn_cancel_is',
      className: 'flexGrowZero formButton mt-24',
    },
    {
      element: 'button',
      type: 'facebook',
      content: claroAdEnable ? Onboarding_IniciaSesionRCU_TextoBotonFacebook : login_access_facebook_button_login,
      onClick: onFacebookClicked,
      disabled: isLogingInWithFacebook,
      id: 'btn_fb_continue',
      className: 'flexGrowZero formButton mt-24',
    },
    {
      element: 'button',
      type: 'apple',
      content: claroAdEnable
        ? Onboarding_IniciaSesionRCU_TextoBotonApple
        : login_access_apple_button_login,
      onClick: onAppleClicked,
      id: 'btn_start_apple',
      className: `flexGrowZero formButton ${
        claroAdEnable ? 'mt-47' : 'mt-24'
      } ${claroAdEnable ? 'text-lowercase' : '' }`,
    },
    claroAdEnable
      ? [
          {
            element: 'message',
            content: Onboarding_IniciaSesionRCU_TextoToggle1,
            position: 'bottom',
            expand: 0.01,
            className: 'flexGrowZero newInClaroMessage mt-17',
          },
          {
            element: 'button',
            type: 'gray',
            content: Onboarding_IniciaSesionRCU_TextoBotonSecundario1,
            onClick: onRegisterClicked,
            className: 'flexGrowZero formButton mt-5',
          },
        ]
      : {
          element: 'message',
          content: login_access_register_label_link,
          position: 'bottom',
          onClick: onRegisterClicked,
          expand: 0.01,
          align: 'center',
          className: `flexGrowZero registerMessage ${
            claroAdEnable ? 'mt-17' : 'mt-47'
          } `,
        },
    GetRegion() === 'mexico' && {
      element: 'message',
      content: telmex_chat_text,
      position: 'bottom',
      expand: 0.01,
      onClick: onChatClicked,
      className: `flexGrowZero chatMessage ${
        claroAdEnable ? 'mt-24' : 'mt-16'
      }`,
    },
  ];

  if (GetRegion() === 'brasil') {
    elements = elements
      .filter(elem => elem.type !== 'apple')
      .map(elem => ({
        ...elem,
        ...(elem.element === 'button' ? { expand: 0.3 } : {}),
      }));
  }

  return <Form elements={elements} classes={['formEmail']} />;
};

EmailForm.propTypes = {
  onRegisterClicked: PropTypes.func.isRequired,
  onCancelClicked: PropTypes.func.isRequired,
  onNextClicked: PropTypes.func.isRequired,
  emailValid: PropTypes.bool,
  onFacebookClicked: PropTypes.func.isRequired,
  onAppleClicked: PropTypes.func.isRequired,
  onChatClicked: PropTypes.func.isRequired,
  clearValidEmailError: PropTypes.func,
  translations: PropTypes.shape({
    loginMail_tooltip_error_label: PropTypes.string,
    email_tooltip_valid_label_validation: PropTypes.string,
    telmex_chat_text: PropTypes.string,
    register_access_title_label: PropTypes.string,
    register_access_description_label: PropTypes.string,
    register_access_option_button_next: PropTypes.string,
    register_access_option_button_cancel: PropTypes.string,
    register_access_termsConditions_label_link: PropTypes.string,
    register_access_promotions_label_link: PropTypes.string,
    register_access_login_label_lin: PropTypes.string,
    register_access_placeHolder_textfield: PropTypes.string,
    password_tooltip_checkTermsConditions_label_validation: PropTypes.string,
    password_tooltip_completeField_label_validation: PropTypes.string,
  }),
  isLogingInWithFacebook: PropTypes.bool,
};

EmailForm.defaultProps = {
  emailValid: true,
};

export default EmailForm;
